<div>
  <div class="card" *ngIf="user">
    <div class="card-header">
      <div>{{ user.name }}</div>
    </div>
    <div class="card-body">
      <form [formGroup]="profileForm" (submit)="submit()">
        <div class="row">
          <div class="col-md-6 col-lg-4">
            <div class="form-group">
              <label for="name">Reset Password</label>
              <input type="text" class="form-control" formControlName="password" />
            </div>
            <button class="btn btn-primary">Update</button>
          </div>
        </div>
      </form>
    </div>
  </div>
</div>
